/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useMemo } from 'react';

import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import type { EventingData } from 'bundles/search-common/components/filters/SearchFilterItem';
import SearchFilterItem from 'bundles/search-common/components/filters/SearchFilterItem';
import { IS_FOR_CREDIT } from 'bundles/search-common/constants/filter';
import type { SearchFilterOption } from 'bundles/search-common/types';
import { getForCreditFilterLabelText } from 'bundles/search-common/utils/forCreditExperimentUtils';

type Props = {
  name: string;
  items?: SearchFilterOption[];
  addFilters?: (x0: string) => void;
  removeFilters?: (x0: string) => void;
  eventingData: EventingData;
  subscriptions?: SubscriptionsV1[];
};

const styles = {
  filterContainer: css`
    margin-bottom: 32px;
  `,
  forCreditFilter: css`
    display: flex;
    align-items: center;
  `,
};

const ForCreditSearchFilter: React.FC<Props> = ({ name, addFilters, removeFilters, items = [], eventingData }) => {
  const forCreditFilterItem = useMemo(
    () => items.find((item) => item.label === 'true') || { isRefined: false, label: 'true', value: 'true', count: 0 },
    [items]
  );

  const forCreditLabelText = getForCreditFilterLabelText();

  if (!forCreditLabelText) return null;

  return (
    <div className="rc-ForCreditFilterCategory" css={styles.filterContainer}>
      <SearchFilterItem
        key={forCreditFilterItem.label}
        {...forCreditFilterItem}
        value={`${IS_FOR_CREDIT}:${forCreditFilterItem.value}`}
        label={forCreditLabelText}
        filterCategoryName={name}
        addFilters={addFilters}
        removeFilters={removeFilters}
        customAriaLabel={forCreditLabelText}
        eventingData={eventingData}
        isCompact={true}
      />
    </div>
  );
};

export default ForCreditSearchFilter;
